export default __webpack_public_path__ + "static/media/shelby-next@3x.b409ee61.png";